import React from 'react';
import { TDR } from 'tdr-common';
import { useTranslation } from 'react-i18next';

type HeaderProps = {
	table: TDR.Table;
	tableName?: string;
	priceElement?: React.ReactNode;
};

export const TableDrawerHeader = ({ table, tableName, priceElement }: HeaderProps) => {
	const { t } = useTranslation();
	const displayName = tableName ?? table.name;
	return (
		<div className="flex flex-col">
			<div className='px-2'>
				<h3 className="text-zinc-500 font-semibold text-sm text-ellipsis capitalize font-poppins">{table.label || t('labels.table', { defaultValue: 'Table' })}</h3>
			</div>
			<div className="flex justify-between px-2 gap-2">
				<h2 className="text-zinc-100 text-ellipsis font-medium text-2xl capitalize font-lora">{displayName}</h2>
				{priceElement}
			</div>
		</div>
	);
};

